<a href="/">
    <img
        *ngIf="!appSession.tenant || !appSession.tenant.HasLogo()"
        [src]="defaultLogoUrl"
        alt="logo"
        class="h-20px h-lg-30px" />
    <img
        *ngIf="appSession.tenant && appSession.tenant.HasLogo()"
        [src]="tenantLogoUrl"
        alt="logo"
        class="h-20px h-lg-30px" />
</a>
